module.exports = __webpack_public_path__ + "static/books-5f4ffb1da17532c709c68a228dfd4ee1.svg";